export enum LayoutLanguage {
    Azerbaijani = 'az',
    English = 'en',
    Russian = 'ru'
  }
  